export class Funcoes {
  constructor({ id, codigo, nome, dataCriacao, vendor_id }) {
    this.id = id;
    this.codigo = codigo;
    this.nome = nome;
    this.dataCriacao = dataCriacao;
    this.vendor_id = vendor_id;
  }
}
